import { useContext } from 'react';
import { SearchContext } from 'context/SearchContext';
import TextDropdown from 'components/common/TextDropdown/TextDropdown';
import { FacetOrder } from 'types/Search';

const sortOptions = [
  {
    value: 'COUNT',
    label: 'Count'
  },
  {
    value: 'NAME',
    label: 'Name'
  }
];

export const FacetOrderSelector = () => {
  const { setFacetOrder, facetOrder } = useContext(SearchContext);
  return (
    <div className={'search-overview-sort'}>
      <TextDropdown
        label="Sort by: "
        name="search-overview-dropdown"
        value={facetOrder}
        onChange={value => setFacetOrder(value as FacetOrder)}
        options={sortOptions}
      />
    </div>
  );
};
